import { CheckCircle2, Circle } from 'lucide-react'

import type {
    SalesOrderStatus,
    SalesOrderStatusLog,
} from '@/lib/api/sales-order-api'
import { STATUS_LABELS } from '@/components/sections/order-status-badge'
import { formatDateTimeVN } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

function statusLabel(raw: string): string {
    return STATUS_LABELS[raw as SalesOrderStatus]?.() ?? raw
}

interface Props {
    logs: SalesOrderStatusLog[]
    isLoading?: boolean
}

export function OrderTimeline({ logs, isLoading }: Props) {
    if (isLoading) {
        return (
            <div className="text-sm text-muted-foreground">
                {m.common_loading()}
            </div>
        )
    }

    if (!logs.length) {
        return (
            <div className="text-sm text-muted-foreground">
                {m.order_no_history()}
            </div>
        )
    }

    // Show newest first so the current status is at the top
    const sorted = [...logs].reverse()

    return (
        <ol className="relative border-l border-border ml-3 space-y-4">
            {sorted.map((log, idx) => (
                <li key={log.id} className="ml-6">
                    <span className="absolute -left-3 flex size-6 items-center justify-center rounded-full bg-background ring-1 ring-border">
                        {idx === 0 ? (
                            <CheckCircle2 className="size-4 text-primary" />
                        ) : (
                            <Circle className="size-4 text-muted-foreground" />
                        )}
                    </span>
                    <div className="flex flex-col gap-0.5">
                        <p className="text-sm font-medium">
                            {/* Cùng trạng thái = sự kiện trên đơn không đổi
                                trạng thái (vd nối SP KiotViet, M-145): chỉ hiện
                                trạng thái hiện tại, nội dung nằm ở ghi chú. */}
                            {log.from_status &&
                            log.from_status !== log.to_status ? (
                                <span>
                                    <span className="text-muted-foreground">
                                        {statusLabel(log.from_status)}
                                    </span>
                                    {' → '}
                                    <span>{statusLabel(log.to_status)}</span>
                                </span>
                            ) : (
                                <span>{statusLabel(log.to_status)}</span>
                            )}
                        </p>
                        {log.changed_by_name && (
                            <p className="text-xs text-muted-foreground">
                                {log.changed_by_name}
                            </p>
                        )}
                        {log.note && (
                            <p className="text-xs text-muted-foreground italic">
                                {log.note}
                            </p>
                        )}
                        <time className="text-xs text-muted-foreground">
                            {formatDateTimeVN(log.created_at)}
                        </time>
                    </div>
                </li>
            ))}
        </ol>
    )
}
